import { ChevronUpDownIcon } from "@heroicons/react/20/solid";

const CalendarEventStudentCard = ({event, setFamilySearchOpen, setSomethingWasChanged, setEventObjectToEdit}) => {

    const calculateAge = (birthday) => { // birthday is a date
        let fixedBDay = new Date(birthday)
         let ageDifMs = Date.now() - fixedBDay.getTime();
         let ageDate = new Date(ageDifMs); // miliseconds from epoch
         if(isNaN(Math.abs(ageDate.getUTCFullYear() - 1970))) {
          return 'Unknown '
         } else {
          return Math.abs(ageDate.getUTCFullYear() - 1970);
         }
      }

      const removeStudent = () => {
        setSomethingWasChanged(true)
        setEventObjectToEdit((prev) => ({...prev, familyId: '', familyName: '', familyAddress: {}, studentId: '', familyPhoneNumber: '', studentDOB: '', parentName: '', studentName: '', waveCustomerId: '', familyEmail: ''}))
      }

      const openTheFamilySearch = () => {
        setSomethingWasChanged(true)
        setFamilySearchOpen(true)
      }

    return (
      <div>
        <div className="block text-sm font-medium mt-5 mb-1 text-gray-700">Student:</div>
        <div className='p-2 border border-solid rounded-md shadow-sm border-gray-300 mt-0'>
        {event.familyId === '' 
        ? 
        <div className="text-left relative" onClick={() => openTheFamilySearch()}>
          <div className='text-black text-sm inline-block py-0 px-3 rounded-md cursor-pointer'>Select Student</div>
          <span className='right-0 absolute'>
            <ChevronUpDownIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
          </span>
        </div> 
        :
        <div>
          <div className='text-right'>
            <div onClick={() => removeStudent()} className='inline-block float-right cursor-pointer text-center align-top font-sm text-xs text-gray-400 hover:text-gray-500'>remove</div>
          </div>
          <div className='mt-0'>
            <label htmlFor="project-name" className="inline-block text-xs w-24 font-medium text-gray-500">
              Student:
            </label>
            <div className='text-left pl-5 inline-block'>
              {event && <div className=' font-bold'>{event.studentName} {event.familyName}</div>}
            </div>
          </div>
          { 
          calculateAge(event.studentDOB)!== 'Unknown ' &&
            <div className='mt-3'>
              <label htmlFor="project-name" className="inline-block text-sm mt-3 w-24 font-medium text-gray-500">
                Age:
              </label>
                <div className='inline-block text-xs pl-5'>
                  {calculateAge(event.studentDOB)} yrs old
                </div>
            </div>
          }
          <div className='mt-3'>
          <label htmlFor="project-name" className="inline-block align-top text-xs mt-3 w-24 font-medium text-gray-500">
            Address:
          </label>
          <div className='text-left text-xs inline-block pl-5 mt-0'>
            {event && <div className=' text-xs pl-0 mt-1'>{event.familyAddress.addressLine1}</div>}
            {event && <div className=' text-xs pl-0'>{event.familyAddress.city}, {event.familyAddress.state}</div>}
            {event && <div className=' text-xs pl-0'>{event.familyAddress.zipcode}</div>}
          </div>
          </div>
          <div>
          <div className='mt-0'>
            <label htmlFor="project-name" className="inline-block text-xs mt-3 w-24 font-medium text-gray-500">
              Parent
            </label>
            <div className='text-left text-xs pl-5 inline-block'>
              {event && <div className=''>{event.parentName} {event.familyName}</div>}
            </div>
          </div>
          <div className='mt-0'>
            <label htmlFor="project-name" className="inline-block text-xs mt-3 w-24 font-medium text-gray-500">
              Phone Number:
            </label>
            <div className='text-left text-xs pl-5 inline-block'>
              {event && <div className=''>{event.familyPhoneNumber}</div>}
            </div>
          </div>
          <div className='mt-0'>
            <label htmlFor="project-name" className="inline-block text-xs mt-3 w-24 font-medium text-gray-500">
              Email:
            </label>
            <div className='text-left text-xs pl-5 inline-block'>
              {event && <div className=''>{event.familyEmail}</div>}
            </div>
          </div>
        </div>
        </div>
        }
      </div>
      </div>
    )
}
export default CalendarEventStudentCard